interface OwnProps {
  imgSrc?: string;
  className?: string;
  title?: string;
}

const ProductCardFlag = ({ imgSrc, title, className }: OwnProps) => (
  <img src={imgSrc} className={className} alt={title} />
);

export default ProductCardFlag;
